import { useEffect, useState } from 'react';
import { Dialog, Pane, Text, Heading } from 'evergreen-ui';
import { fetchGuestAttachments } from '../services/guestsServices';
import { ATTACHMENT_CATEGORIES } from '../constants/guestAttachments';

const GuestViewDialog = ({ isShown, onClose, guest }) => {
  const [attachments, setAttachments] = useState([]);

  useEffect(() => {
    if (!isShown || !guest || !guest.id) return;
    let cancelled = false;
    const load = async () => {
      try {
        const atts = await fetchGuestAttachments(guest.id);
        if (!cancelled) setAttachments(atts || []);
      } catch (err) {
        console.error('Errore fetch attachments in GuestViewDialog', err);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [isShown, guest]);

  const title = guest ? `Dettagli ospite: ${guest.nome || ''} ${guest.cognome || ''}` : 'Dettagli ospite';

  return (
    <Dialog isShown={isShown} title={title} onCloseComplete={onClose} hasFooter={false} shouldAutoFocus={false}>
      <Pane display="flex" flexDirection="column" gap={8}>
        {!guest ? (
          <Text>Caricamento...</Text>
        ) : (
          <>
            <Pane>
              <Text><strong>Nome:</strong> {guest.nome}</Text>
            </Pane>
            <Pane>
              <Text><strong>Cognome:</strong> {guest.cognome}</Text>
            </Pane>
            <Pane>
              <Text><strong>Sesso:</strong> {guest.sesso}</Text>
            </Pane>
            <Pane>
              <Text><strong>Data di nascita:</strong> {guest.data_nascita ? guest.data_nascita.split('-').reverse().join('/') : ''}</Text>
            </Pane>
            <Pane>
              <Text><strong>Luogo di nascita:</strong> {guest.luogo_nascita}</Text>
            </Pane>
            <Pane>
              <Text><strong>Residenza:</strong> {guest.residenza}</Text>
            </Pane>
            <Pane>
              <Text><strong>Domicilio:</strong> {guest.domicilio}</Text>
            </Pane>
            <Pane>
              <Text><strong>Motivazione:</strong> {guest.motivazione}</Text>
            </Pane>

            {(guest.iban || guest.telefono || guest.email) && (
              <Pane marginTop={8}>
                <Heading size={300} marginBottom={4}>Contatti ospite</Heading>
                {guest.iban && <Text display="block"><strong>IBAN:</strong> {guest.iban}</Text>}
                {guest.telefono && <Text display="block"><strong>Telefono:</strong> {guest.telefono}</Text>}
                {guest.email && <Text display="block"><strong>Email:</strong> {guest.email}</Text>}
              </Pane>
            )}

            {[
              { label: 'Avvocato', prefix: 'avv' },
              { label: 'Assistente sociale', prefix: 'ass' },
              { label: 'Specialista di riferimento', prefix: 'spec' },
              { label: 'SerD', prefix: 'serd' },
              { label: 'Madre', prefix: 'madre' },
              { label: 'Padre', prefix: 'padre' },
            ].map(({ label, prefix }) => {
              const nome = guest[`${prefix}_nome`];
              const cognome = guest[`${prefix}_cognome`];
              const mail = guest[`${prefix}_mail`];
              const tel = guest[`${prefix}_telefono`];
              const ind = guest[`${prefix}_indirizzo`];
              if (!nome && !cognome && !mail && !tel && !ind) return null;
              return (
                <Pane key={prefix} marginTop={8}>
                  <Heading size={300} marginBottom={4}>{label}</Heading>
                  {(nome || cognome) && <Text display="block"><strong>Nome:</strong> {[nome, cognome].filter(Boolean).join(' ')}</Text>}
                  {tel && <Text display="block"><strong>Telefono:</strong> {tel}</Text>}
                  {mail && <Text display="block"><strong>Email:</strong> {mail}</Text>}
                  {ind && <Text display="block"><strong>Indirizzo:</strong> {ind}</Text>}
                </Pane>
              );
            })}

            <Pane>
              <Text><strong>PEI:</strong> {guest.revisione_pei_url ? <Text cursor="pointer" color="blue" onClick={() => window.open(guest.revisione_pei_url, '_blank', 'noopener,noreferrer')}>{guest.revisione_pei_url.split('/').pop()}</Text> : 'Nessun PEI'}</Text>
            </Pane>

            <Pane>
              <Text fontWeight={600}>Allegati</Text>
              {attachments.length === 0 ? (
                <Text display="block" marginTop={6}>Nessun allegato.</Text>
              ) : (
                <Pane marginTop={6} display="flex" flexDirection="column" gap={8}>
                  {ATTACHMENT_CATEGORIES.map(cat => {
                    const items = attachments.filter(a => a.category === cat);
                    if (items.length === 0) return null;
                    return (
                      <Pane key={cat}>
                        <Text size={300} fontWeight={600} textTransform="capitalize">{cat}</Text>
                        <Pane display="flex" flexDirection="column" gap={4} marginTop={2}>
                          {items.map(att => (
                            <Text key={att.id} cursor="pointer" color="blue" onClick={() => window.open(att.file_url, '_blank', 'noopener,noreferrer')}>{att.file_name}</Text>
                          ))}
                        </Pane>
                      </Pane>
                    );
                  })}
                  {attachments.filter(a => !a.category).length > 0 && (
                    <Pane>
                      <Text size={300} fontWeight={600}>Senza categoria</Text>
                      <Pane display="flex" flexDirection="column" gap={4} marginTop={2}>
                        {attachments.filter(a => !a.category).map(att => (
                          <Text key={att.id} cursor="pointer" color="blue" onClick={() => window.open(att.file_url, '_blank', 'noopener,noreferrer')}>{att.file_name}</Text>
                        ))}
                      </Pane>
                    </Pane>
                  )}
                </Pane>
              )}
            </Pane>
          </>
        )}
      </Pane>
    </Dialog>
  );
};

export default GuestViewDialog;
